import React from 'react'
import {
  IcoStepsOne,
  IcoStepsTwo,
  IcoStepsCheck,
  IcoStepsTwoDisabled,
} from '../../../../lib/svg'
const HeadersSteps = props => {
  return (
    <div className="wrapper-header-form">
      <p className="ahorroYa-register__form__title_card">
        Si tienes tu <strong>Fondo Obligatorio</strong> o una
        <span> </span>
        <strong>Cuenta de Aportes Voluntarios*</strong>
        en Prima AFP
      </p>
      <p className="ahorroYa-register__form__subTitle flex justify-center mt-2">
        ¡Empieza a ahorrar con tus consumos!
      </p>

      <div className="ahorroYa_form_wrapper_steps">
        <div className="ahorroYa_form_steps">
          {props.step === 1 ? <IcoStepsOne /> : <IcoStepsCheck />}
          <p
            style={
              props.step === 1 ? { color: '#4E5258' } : { color: '#04A6A2' }
            }
          >
            Ingresa tus datos
          </p>
        </div>
        <div
          className="line_steps"
          style={
            props.step === 1
              ? { background: '#c5c7c8' }
              : { background: '#04A6A2' }
          }
        ></div>
        <div className="ahorroYa_form_steps">
          {props.step === 1 && <IcoStepsTwoDisabled />}
          {props.step > 1 && <IcoStepsTwo />}

          <p style={{ color: '#4E5258' }}>Valida tu identidad</p>
        </div>
      </div>
    </div>
  )
}

export default HeadersSteps
